import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cabae05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_3 = { class: "ion-margin-top" }
const _hoisted_4 = { id: "paymentModalContent" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "payment-title" }
const _hoisted_7 = { class: "check" }
const _hoisted_8 = { class: "payment-type-option-title" }
const _hoisted_9 = { class: "payment-type-option-desc" }
const _hoisted_10 = { class: "check" }
const _hoisted_11 = { class: "payment-type-option-title" }
const _hoisted_12 = { class: "payment-type-option-desc" }
const _hoisted_13 = { class: "check" }
const _hoisted_14 = { class: "payment-type-option-title" }
const _hoisted_15 = { class: "payment-type-option-desc" }
const _hoisted_16 = { class: "check" }
const _hoisted_17 = { class: "payment-type-option-title" }
const _hoisted_18 = { class: "payment-type-option-desc" }
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_split_bill = _resolveComponent("split-bill")!
  const _component_select_items = _resolveComponent("select-items")!
  const _component_pay_all = _resolveComponent("pay-all")!
  const _component_pay_my_items = _resolveComponent("pay-my-items")!
  const _component_ng_template = _resolveComponent("ng-template")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_ion_modal, {
      ref: "modal",
      class: _normalizeClass(["payment-modal", { 'modal-select-items': _ctx.selectedPaymentType === 2 }]),
      "is-open": _ctx.isOpen,
      "initial-breakpoint": 1,
      breakpoints: _ctx.breakPoints,
      "presenting-element": _ctx.$parent.$refs.ionRouterOutlet,
      onDidDismiss: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isOpen = false)),
      handle: false,
      onIonModalWillPresent: _ctx.getPaymentInfo
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ng_template, null, {
          default: _withCtx(() => [
            (_ctx.paymentInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false)),
                    class: "bottom-modal-close-btn"
                  }, [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.selectedPaymentType === null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.$t("payment.title")), 1),
                            (_ctx.paymentInfo.available_payment_types.includes(0))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "payment-type-option",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPaymentType(0)))
                                }, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.ellipseOutline }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("payment.paymentType0Name")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("payment.paymentType0Sub")) + " (" + _toDisplayString(_ctx.$filters.currency(_ctx.paymentInfo.total)) + ") ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("payment.paymentType0Desc")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                _ctx.paymentInfo.available_payment_types.includes(3) &&
                _ctx.paymentInfo.total_my_items > 0
              )
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPaymentType(3))),
                                  class: _normalizeClass(["payment-type-option", _ctx.selectedPaymentType === 3])
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.ellipseOutline }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("payment.paymentType3Name")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("payment.paymentType3Sub")) + " (" + _toDisplayString(_ctx.$filters.currency(_ctx.paymentInfo.total_my_items)) + ") ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("payment.paymentType3Desc")), 1)
                                  ])
                                ], 2))
                              : _createCommentVNode("", true),
                            (_ctx.paymentInfo.available_payment_types.includes(1))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPaymentType(1))),
                                  class: _normalizeClass(["payment-type-option", _ctx.selectedPaymentType === 1])
                                }, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.ellipseOutline }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("payment.paymentType1Name")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("payment.paymentType1Sub")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("payment.paymentType1Desc")), 1)
                                  ])
                                ], 2))
                              : _createCommentVNode("", true),
                            (_ctx.paymentInfo.available_payment_types.includes(2))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: "payment-type-option",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPaymentType(2)))
                                }, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.ellipseOutline }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("payment.paymentType2Name")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("payment.paymentType2Sub")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("payment.paymentType2Desc")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPaymentType === 1)
                        ? (_openBlock(), _createBlock(_component_split_bill, {
                            key: 1,
                            paymentInfo: _ctx.paymentInfo,
                            onBack: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPaymentType(null))),
                            onPay: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pay($event))),
                            onTipUpdated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tip = $event))
                          }, null, 8, ["paymentInfo"]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPaymentType === 2)
                        ? (_openBlock(), _createBlock(_component_select_items, {
                            key: 2,
                            paymentInfo: _ctx.paymentInfo,
                            onBack: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPaymentType(null))),
                            onPay: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pay($event))),
                            onTipUpdated: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tip = $event))
                          }, null, 8, ["paymentInfo"]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPaymentType === 0)
                        ? (_openBlock(), _createBlock(_component_pay_all, {
                            key: 3,
                            paymentInfo: _ctx.paymentInfo,
                            onBack: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setPaymentType(null))),
                            onPay: _ctx.pay,
                            onTipUpdated: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tip = $event))
                          }, null, 8, ["paymentInfo", "onPay"]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPaymentType === 3)
                        ? (_openBlock(), _createBlock(_component_pay_my_items, {
                            key: 4,
                            paymentInfo: _ctx.paymentInfo,
                            onBack: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setPaymentType(null))),
                            onTipUpdated: _cache[14] || (_cache[14] = ($event: any) => (_ctx.tip = $event)),
                            onPay: _ctx.pay
                          }, null, 8, ["paymentInfo", "onPay"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "class", "breakpoints", "presenting-element", "onIonModalWillPresent"]),
    _createVNode(_component_ion_modal, {
      ref: "modalIframe",
      "is-open": _ctx.isIframeOpen,
      "presenting-element": _ctx.$parent.$refs.ionRouterOutlet,
      onDidDismiss: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isIframeOpen = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ng_template, null, {
          default: _withCtx(() => [
            _createElementVNode("iframe", {
              src: this.paymentUrl
            }, null, 8, _hoisted_19)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "presenting-element"])
  ], 64))
}